export const SupportedArtworkSizes = {
    default: [220, 220],
    label: [192, 192],
    desktop: [260, 260],
    customHeroSlide: [450, 365],
    heroSlide: [500, 500],
} as const;
